const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/modules/CIS4m/components/CIS4mHiddenField.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useValueMessaging } from '../hooks';
import { CIS4mValueComponentProps } from '../types';

interface Props extends CIS4mValueComponentProps {}

export const CIS4mHiddenField = forwardRef((props: Props, ref: any) => {
    const { path, initialValue, hidden = false } = props;
    useValueMessaging(ref, { hidden, initialValue, path });

    return <></>;
});

CIS4mHiddenField.displayName = 'CIS4mHiddenField';
